/* Favoritos — la página. Cuadros Splash

   Lee la lista de handles guardada por favoritos.js y pide la ficha de cada
   producto a su endpoint público JSON (/products/<handle>.js). Solo se
   carga en /pages/favoritos — depende de window.csFavoritos, que expone
   favoritos.js en todas las páginas.

   La imagen es la foto normal del catálogo (el mockup de salón), la misma
   que ya se ve en cualquier colección: esta página es un listado de
   utilidad, no el escaparate curado de la portada, así que no hace falta
   resolver la "obra limpia" — eso pediría los metafields, que el endpoint
   público de producto no trae.
*/

(function () {
  // Raíz del idioma: '/' en español, '/en/' en inglés. Un '/products/' a mano
  // devolvería al cliente a la web en español.
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function formatearPrecio(centavos) {
    var euros = (centavos / 100).toFixed(2).replace('.', ',');
    return euros + ' €';
  }

  function referenciaDe(sku) {
    if (!sku) return '';
    return sku.split('-')[0];
  }

  function pedirProducto(handle) {
    return fetch(raiz + 'products/' + handle + '.js')
      .then(function (resp) {
        return resp.ok ? resp.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function montarTarjeta(plantilla, producto) {
    var nodo = plantilla.content.firstElementChild.cloneNode(true);
    var img = nodo.querySelector('.cs-obra__img');
    var imagenUrl = producto.featured_image || (producto.images && producto.images[0]) || '';

    nodo.href = raiz + 'products/' + producto.handle;
    img.src = imagenUrl;
    img.alt = producto.title;
    nodo.querySelector('.cs-obra__t').textContent = producto.title;

    var primeraVariante = producto.variants && producto.variants[0];
    nodo.querySelector('.cs-obra__ref').textContent = referenciaDe(primeraVariante && primeraVariante.sku);

    var precios = (producto.variants || []).map(function (v) {
      return v.price;
    });
    var precioMin = precios.length ? Math.min.apply(null, precios) : producto.price;
    nodo.querySelector('[data-precio]').textContent = csT('paginas.favoritos.desde', 'Desde {precio}').replace(
      '{precio}',
      formatearPrecio(precioMin)
    );

    var boton = nodo.querySelector('[data-cs-fav]');
    if (boton) boton.dataset.csFav = producto.handle;

    return nodo;
  }

  function marcarVacio(vacio, contenedor) {
    if (vacio) vacio.hidden = !(contenedor && !contenedor.children.length);
  }

  function pintar() {
    var contenedor = document.querySelector('[data-cs-fav-lista]');
    var vacio = document.querySelector('[data-cs-fav-vacio]');
    var plantilla = document.querySelector('[data-cs-fav-plantilla]');
    var vaciar = document.querySelector('[data-cs-fav-vaciar]');
    if (!contenedor || !plantilla || !window.csFavoritos) return;

    var handles = window.csFavoritos.leer();
    if (vaciar) vaciar.hidden = !handles.length;
    if (!handles.length) {
      contenedor.innerHTML = '';
      if (vacio) vacio.hidden = false;
      return;
    }

    Promise.all(handles.map(pedirProducto)).then(function (resultados) {
      var validos = resultados.filter(Boolean);

      contenedor.innerHTML = '';
      validos.forEach(function (producto) {
        contenedor.appendChild(montarTarjeta(plantilla, producto));
      });
      if (vacio) vacio.hidden = !!validos.length;
      if (vaciar) vaciar.hidden = !validos.length;

      // Poda en silencio los handles que ya no resolvieron nada (producto
      // borrado u oculto), para que la lista guardada no acumule basura.
      if (validos.length !== handles.length) {
        window.csFavoritos.guardar(
          validos.map(function (p) {
            return p.handle;
          })
        );
      }
    });
  }

  // Quitar un favorito desde esta misma página no necesita volver a pedir
  // todo: basta con retirar su tarjeta.
  document.addEventListener('cs:favoritos-cambio', function (e) {
    if (e.detail.favorito) return;
    var contenedor = document.querySelector('[data-cs-fav-lista]');
    if (!contenedor) return;
    var boton = contenedor.querySelector('[data-cs-fav="' + CSS.escape(e.detail.handle) + '"]');
    var tarjeta = boton && boton.closest('.cs-obra');
    if (tarjeta) tarjeta.remove();
    marcarVacio(document.querySelector('[data-cs-fav-vacio]'), contenedor);
    var vaciar = document.querySelector('[data-cs-fav-vaciar]');
    if (vaciar) vaciar.hidden = !window.csFavoritos.leer().length;
  });

  document.addEventListener('click', function (e) {
    var vaciar = e.target.closest && e.target.closest('[data-cs-fav-vaciar]');
    if (!vaciar || !window.csFavoritos) return;

    if (!window.confirm(csT('paginas.favoritos.confirmar_vaciar', '¿Seguro que quieres vaciar todos tus favoritos?'))) return;

    window.csFavoritos.guardar([]);
    var contenedor = document.querySelector('[data-cs-fav-lista]');
    var vacio = document.querySelector('[data-cs-fav-vacio]');
    if (contenedor) contenedor.innerHTML = '';
    marcarVacio(vacio, contenedor);
    vaciar.hidden = true;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pintar);
  } else {
    pintar();
  }
  document.addEventListener('shopify:section:load', pintar);
})();
